<template>
  <div>
    <v-dialog
      :model-value="showDialog"
      width="auto"
      @update:model-value="handleClose"
    >
      <v-card class="card br-5">
        <v-toolbar
          color="rgba(0, 0, 0, 0)"
          class="mb-3"
        >
          <div class="pl-4 card__instructions-text">
            {{ message }}
          </div>
          <template #append>
            <v-btn
              icon="mdi-close"
              variant="text"
              @click="handleClose()"
            />
          </template>
        </v-toolbar>
        <v-card-text class="pt-0 pb-2 px-4">
          <slot name="dialog-container" />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script lang="ts">
export default {
  name: 'SharedMapDialogView',
  props: {
    showDialog: {
      type: Boolean,
      required: true,
    },
    message: {
      type: String,
      required: true,
    },
  },
  emits: ['input', 'close'],
  methods: {
    handleClose() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
.card {
  padding: 10px 10px 20px 10px;
  width: 615px;
  @include main.custom-width(640, auto);

  &__instructions-text {
    color: main.$npGray;
    font-weight: 800;
    @media(max-width: 700px) {
      max-width: 400px;
    }
  }
}
:deep(.v-select .v-field.v-field) {
  padding-right: 5px;
}
:deep(.v-select__selection-text) {
  font-size: 14px;
}
:deep(.v-list-item-title) {
  font-size: 14px;
}
</style>
